export default function Footer() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-100">
                51吃瓜黑料
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              热点爆料聚合平台 —— 汇集最新吃瓜爆料、黑料曝光、今日黑料及网曝门事件内幕。实时更新独家猛料，持续吃瓜不迷路。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '实时快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '常见问答', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  娱乐圈爆料
                </a>
              </li>
              <li>
                <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  网红圈内幕
                </a>
              </li>
              <li>
                <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  社会热点解读
                </a>
              </li>
              <li>
                <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  电竞圈故事
                </a>
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴正在加入中，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51吃瓜黑料网. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#about" onClick={(e) => scrollTo(e, '#about')} className="hover:text-primary-400 transition-colors cursor-pointer">
              关于我们
            </a>
            <a href="#contact" onClick={(e) => scrollTo(e, '#contact')} className="hover:text-primary-400 transition-colors cursor-pointer">
              联系我们
            </a>
            <a href="#faq" onClick={(e) => scrollTo(e, '#faq')} className="hover:text-primary-400 transition-colors cursor-pointer">
              常见问答
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}